// extracted by mini-css-extract-plugin
module.exports = {"microCard":"OverviewProductDetailsPanel_microCard__PU4y3"};